// extracted by mini-css-extract-plugin
export var brand = "_a1-9";
export var compact = "_a1-6";
export var extraSmall = "_a1-7";
export var icon = "_a1-0";
export var large = "_a1-4";
export var light = "_a1-1";
export var medium = "_a1-5";
export var outline = "_a1-b";
export var primaryDark = "_a1-a";
export var primaryLight = "_a1-8";
export var primaryModern = "_a1-c";
export var success = "_a1-2";
export var successSolid = "_a1-3";